import { graphql } from 'react-apollo';

export default (query, options) => graphql(
  query, {
    options,
    props: ({ data }) => ({ ...data }),
  },
);
